const newTechnologyData = {
  images: {
    desktop:
      'https://res.cloudinary.com/benchmarkminerals/image/upload/c_fill,q_auto,g_auto,w_1920,f_auto/v1750889551/assets/market/new-technology/new-technology-portal_kiycqo.png',
    mobile:
      'https://res.cloudinary.com/benchmarkminerals/image/upload/c_fill,q_auto,g_auto,w_1024,f_auto/v1750889551/assets/market/new-technology/new-technology-portal_kiycqo.png',
  },
  subTitle: "Benchmark's New Technology service gives users access to:",
  listItems: [
    'Quarterly data-driven technology reports',
    'Bi-annual battery cell cost calculator',
    'Comprehensive capacity database of emerging battery innovators',
    'Tracked TRL, financing stage, and cell performance specifications',
  ],
}

export default newTechnologyData
